import * as Request from '../Request';

const Common = {
  uploadImg: (data) => {
    return Request.post('/common/picture/upload', data);
  },
  // 获取部门树
  departmentTree: (data) => {
    return Request.get('/sys/dept/tree', data);
  },
  // 上传图片
  upload: (data) => {
    return Request.post('/common/picture/upload', data);
  }

}
export default Common
